// material
import { Box, Grid, Container, Typography } from '@mui/material';
// components
import Page from '../components/configs/Page';
import {
  //IMCCard,
  //IdadeCard,
  //UtentesCard,
  //UltimosComentarios,
  //AmplitudesArticulares,
  Satisfacao,
  AtividadeNoSistema,
  //NrExercicios, //barra debaixo deslizante c filtro
  AtividadeUtentes,
  //ExerciciosMaisPraticados,
  //Diagnostico,
  TaxaCorrecaoPostura,
  TaxaRealizacaoExercicios,
  DorEsforcoExercicios,
  DorEsforcoUtentes,
  //HarmoniaDoGesto
  //Esforco
} from '../components/dash_charts';

//import IdadeCard from '../components/dash_charts/IdadeCard'
//import AmplitudesArticulares from '../components/dash_charts/AmplitudesArticulares'

// ----------------------------------------------------------------------

export default function DashboardApp() {
  return (
    <Page title="INPACT | Dashboard">
      <Container maxWidth="xl">
        <Box sx={{ pb: 5 }}>
          <Typography variant="h4">Visão Geral dos Seus Utentes</Typography>
        </Box>
        {/* Cartões números com icone */}
        
        <Grid container spacing={3}>
          
          {/* Gráficos */}
          <Grid item xs={12} md={6} lg={7}>
            <AtividadeNoSistema />
          </Grid>

          {/*
          <Grid item xs={12} md={6} lg={5}>
            <Diagnostico />
          </Grid>
          */}
          <Grid item xs={12} md={6} lg={5}>
            <AtividadeUtentes />
          </Grid>

          <Grid item xs={12} md={6} lg={4}>
            <DorEsforcoUtentes />
          </Grid>

          <Grid item xs={12} md={6} lg={4}>
            <Satisfacao />
          </Grid>


          <Grid item xs={12} md={6} lg={4}>
            <DorEsforcoExercicios />
          </Grid>


          <Grid item xs={12} md={6} lg={6}>
            <TaxaRealizacaoExercicios />
          </Grid>

          <Grid item xs={12} md={6} lg={6}>
            <TaxaCorrecaoPostura />
          </Grid>


          {/*
          <Grid item xs={12} md={6} lg={4}>
            <ExerciciosMaisPraticados />
          </Grid>
          */}

          {/*
          <Grid item xs={12} md={6} lg={5}>
            <AmplitudesArticulares />
          </Grid>
          
          <Grid item xs={12} md={6} lg={12}>
            <Esforco />
          </Grid>
          
          <Grid item xs={12} md={6} lg={8}>
            <NrExercicios />
          </Grid>
          
          <Grid item xs={12} md={6} lg={8}>
            <UltimosComentarios />
          </Grid>
          */}
          
        </Grid>
      </Container>
    </Page>
  );
}
